<template>
  <div class="menu menu-bar-drawer desktop-nav">
    <div class="menu-bar menu-bar-container">
      <div v-if="!enableNewNavigation" class="control-nav-items items" :class="enableBrowseRoomPages ? 'room-browse-test-desktop' : 'room-browse-control-desktop' ">
        <div v-for="item in items" :key="'item-' + item.id" class="menu-item" :class="item.name">
          <template>
            <a
              class="menu-link control"
              :class="{ 'menu-link-active': routeItem && '' + item.id === '' + (routeItem.parentId || routeItem.id) }"
              :href="item.url == ''? null : item.url "
            >
              <span class="menu-item-name control"> {{ item.name }} </span>
            </a>
            <div class="menu-dropdown">
              <ul v-if="item && item.items && item.items.length > 0">
                <li v-for="(subItem, i) in item.items" :key="'item-item-' + subItem.id" class="menu-dropdown-item text-nav">
                  <a :class="subItem.name" @click="loadSectionUrl(subItem.url)"  :href="subItem.url == ''? null : subItem.url ">
                    {{ subItem.name }}
                  </a>
                </li>
              </ul>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SecondaryMenu from '@/components/header/SecondaryMenu.vue';
import Tracking from '@/components/commons/Tracking.js';
import { Image as ResponsiveImage, PreserveRatio } from '@article/pixel';
import { browseRoomPageTestCondition } from '@/components/commons/utils.js';

export default {
  name: 'PageMenu',
  components: {
    ResponsiveImage,
    PreserveRatio,
    SecondaryMenu,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    routeItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      secondaryMenuItemToShow: '',
      topLevelMenuItem: '',
      enableNewNavigation: false,
      enableBrowseRoomPages: browseRoomPageTestCondition(),
    };
  },

  mounted: function() {
    let body = document.body,
      timer;
  },
  methods: {
    startHotJarRecording(){
        if(this.enableNewNavigation && window.hj){
            window.hj('trigger', 'image_nav');
        }
    },

    loadSectionUrl(url) {
      Tracking.track('NAV_ITEM_CLICKED', { newNavEnabled: this.enableNewNavigation, target: url });
      window.location = url;
    },

    isTopLevelMenuItemInactive(menuItem) {
      return (
        menuItem &&
        this.topLevelMenuItem === menuItem.name &&
        this.routeItem &&
        menuItem.id.toLowerCase() !== this.routeItem.parentMenuItem.toLowerCase()
      );
    },
    isSecondaryLeveLMenuItemActive(menuItem) {
      return (
        menuItem &&
        this.routeItem &&
        (this.routeItem.parentMenuItem === 'product' || this.routeItem.name === menuItem.name) &&
        (this.routeItem.id === menuItem.id || this.routeItem.parentId === menuItem.id)
      );
    },
    hasSecondaryLeveLMenuItems(menuItem) {
      return (
        menuItem &&
        menuItem.items &&
        menuItem.items[0] &&
        menuItem.items[0].path?.includes(this.secondaryMenuItemToShow) &&
        this.secondaryMenuItemToShow !== ''
      );
    },
    showArrow(subItem, item) {
      return subItem && item && subItem.name.toUpperCase() !== 'NEW' && item.id.toLowerCase() === 'product';
    },
  },
};
</script>
<style lang="scss">
@import '~@article/pixel/dist/style/variables';
.image-nav-items {
  .menu-item {
    &.Sale,
    &.New {
      display: none;
    }
  }
}

.menu {
  background-color: var(--white);
  width: 100%;

  .menu-link-inactive {
    color: var(--grey-dark);
  }

  .items {
    display: flex;
    &.control-nav-items {
      > div {
        position: relative;
      }
    }
  }

  .force-control-nav {
    position: relative;
  }

  .menu-link {
    display: block;
    color: var(--grey-medium);
    font-size: var(--font-size-14);
    line-height: var(--line-height-14);
    &.control {
      position: relative;
    }

    &:hover {
      color: var(--grey-dark);
    }

    &.menu-link-active {
      color: var(--accent-color);
    }
  }

  .menu-dropdown {
    z-index: 12;
    box-shadow: 0 var(--box-shadow-blur) var(--box-shadow-spread) var(--shadow-color);
    display: flex;
    border-radius: var(--space-1);
    opacity: 0;
    position: absolute;
    list-style-type: none;
    margin: 0;
    margin-top: 15px;
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    visibility: hidden;
    background-color: var(--white);
    font-family: var(--font-regular);
    left: -16px;

    &.image-nav-dropdown {
      position: absolute;
      left: 50%;
      transition-delay: 0.3s;
      transform: translateY(-2px) translateX(-50vw);
      width: calc((100% + (100vw - 100%)) - 8px);
      z-index: -1;

      ul {
        padding-bottom: var(--space-4);
      }

      @media (min-width: 1920px) {
        width: calc((100% + (100vw - 100%)) + (100vw - 1920px) - 8px);
      }

      @media (max-width: $desktop-breakpoint - 1) {
        justify-content: center;
      }
    }

    .main {
      padding: 24px;
      max-width: 320px;
      a {
        padding: 16px;
      }
      img {
        display: block;
        margin: 0 auto;
      }
    }

    ul {
      width: 100%;
      text-align: left;
      box-sizing: content-box;
      min-width: 200px;
      opacity: 0;
    }

    &.image-nav-dropdown ul {
      padding: 16px;
      max-width: 600px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      opacity: 0;
      transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      transition-delay: 0.3s;
      pointer-events: none;

      @media (min-width: $desktop-breakpoint - 1) {
        margin-left: 160px;
      }

      @media (min-width: 1920px) {
        margin-left: calc((100vw - 1920px) / 2 + 160px);
      }
    }
  }

  .menu-dropdown-item {
    font-size: var(--font-size-14);
    width: 100%;
    line-height: 1.25rem;
    white-space: normal;
    &:not(.image-nav) {
      > a {
        padding: 12px 16px;
      }
    }
    &.image-nav {
      background-color: var(--white);
      width: calc(33% - 32px);
      padding: 16px;
      text-align: center;
      cursor: pointer;
      border: 1px solid white;
      border-radius: var(--container-border-radius);
      &:hover {
        border-color: var(--grey-ultra-light);
      }

      &.main {
        opacity: 0;
        transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        transition-delay: 0.3s;
        a {
          border: 1px solid white;
          border-radius: var(--container-border-radius);
        }
        &:hover {
          border-color: white;
          a:hover {
            border-color: var(--grey-ultra-light);
          }
        }
      }
    }

    .section-image {
      transition-duration: 0.3s;
    }

    &.main {
      img {
        padding-bottom: var(--space-4);
      }

      a {
        text-align: left;
      }
    }

    &:not(:last-child) {
      border-bottom: solid 1px var(--white);
    }

    &:first-child {
      border-radius: 4px 4px 0px 0px;
    }

    &:last-child {
      border-radius: 0px 0px 4px 4px;
    }

    .section-image {
      width: 100%;
      max-width: 125px;
      height: auto;
      margin: 0 auto;
      padding-bottom: var(--space-4);
      img {
        display: block;
        width: 100%;
        min-height: 100%;
      }
    }

    .menu-link {
      display: block;
      color: var(--font-color);
      font-size: var(--font-size-14);
      line-height: var(--line-height-14);
    }

    a {
      line-height: 1;
      text-decoration: none;
      display: block;
      transition-duration: 0.2s;

      &:hover {
        color: var(--accent-color);
        transition-duration: 0.2s;
      }

      span {
        height: var(--space-10);
        width: var(--space-10);
        border-radius: 20px;
        float: right;
        text-align: center;
      }

      &.menu-link-active {
        color: var(--accent-color) !important;
      }
    }

    &:hover {
      cursor: pointer;

      a.control {
        color: var(--accent-color);
      }
    }
  }

  .menu-item {
    background-color: var(--white);
    margin-top: 15px;
    padding-bottom: 15px;
    margin-left: var(--space-4);
    white-space: nowrap;

    a.control {
      &:hover {
        color: var(--accent-color);
      }
      span.control {
        &:hover {
          color: var(--accent-color);
        }
      }
    }

    &:hover,
    .menu-link-active {
      > a {
        color: var(--accent-color);
      }

      .menu-dropdown {
        opacity: 1;

        visibility: visible;

        .main,
        ul {
          opacity: 1;
        }
        &.image-nav-dropdown {
          z-index: 1;
          transform: translateY(0px) translateX(-50vw);
          transition-delay: 0.25s;

          .main {
            transition-delay: 0.2s;
            transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            opacity: 1;
          }
          ul {
            transition-delay: 0.2s;
            transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            pointer-events: all;
            opacity: 1;
          }
        }

        li.control {
          a:hover {
            color: var(--accent-color) !important;
          }
        }
      }
    }
  }
}
</style>
